import React from 'react';
import { Button, Container, Divider, IconButton, Typography } from '@mui/material';
import {
  ShoppingCart,
  Facebook,
  YouTube,
  Instagram,
  WhatsApp,
  LinkedIn,
} from '@mui/icons-material';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const whatsappLink = 'https://wa.me/5511988142012';
  const linkedinLink = 'https://www.linkedin.com/company/90832836/admin/page-posts/published/';
  const instagramLink = 'https://www.instagram.com/cisp1.io/';
  return (
    <footer className={styles.footer}>
      <Container maxWidth="lg" className={styles.footerContainer}>
        <div className={styles.footerTop}>
          {/* CISP Logo */}
          <div className={styles.footerLogo}>
            <img src="/images/cisp1-white-logo.png" alt="CISP" />
          </div>

          {/* Talk to Consultants Button */}
          <Button
            variant="contained"
            startIcon={<ShoppingCart className={styles.buttonIcon} />}
            className={styles.consultantButton}
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textTransform: 'none' }}
          >
            Fale com nossos consultores
          </Button>
        </div>

        {/* Divider */}
        <Divider className={styles.divider} sx={{ width: '98%', margin: '0 auto' }} />

        {/* Social Media and Disclaimer */}
        <div className={styles.footerBottom}>
          <div className={styles.socialIcons}>
            <IconButton
              component="a"
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
            >
              <WhatsApp />
            </IconButton>
            <IconButton
              component="a"
              href={linkedinLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
            >
              <LinkedIn />
            </IconButton>
            <IconButton
              component="a"
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
            >
              <Instagram />
            </IconButton>
          </div>
          <Typography variant="caption" className={styles.disclaimer}>
            *Imagens meramente ilustrativas. As cores, modelos e especificações de equipamentos
            variam de acordo com a região e disponibilidade.
          </Typography>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
